import axios from "axios";

const API_BASE_URL = (
  process.env.REACT_APP_API_URL ||
  "https://api.bsangam.com"
).replace(/\/$/, "");

const POST_BASE_URL =
  `${API_BASE_URL}/posts`;

// ==========================
// ADD POST SHARE
// ==========================
export const addPostShareApi = async (
  payload: {
    post_id: number | string;
    client_id: number | string;
    share_type: string;
  }
) => {
  try {
    const formData = new FormData();

    formData.append(
      "post_id",
      String(payload.post_id)
    );

    formData.append(
      "client_id",
      String(payload.client_id)
    );

    formData.append(
      "share_type",
      payload.share_type
    );

    const res = await axios.post(
      `${POST_BASE_URL}/share/add`,
      formData,
      {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },
      }
    );

    return res.data;
  } catch (error: any) {
    return {
      success: false,
      status: false,
      data: null,
      message:
        error?.response?.data?.message ||
        "Failed to update share count",
    };
  }
};
